module.exports = __webpack_public_path__ + "static/media/splash.0b90c61d.jpg";